require('bootstrap-loader/lib/bootstrap.loader?configFilePath='+__dirname+'/../bootstraprc.json!bootstrap-loader/no-op.js')

